import { ApolloClient, useApolloClient } from '@apollo/client';
import gql from 'graphql-tag';
import { get } from 'lodash';
import { useCallback, useEffect, useState } from 'react';

export function useDbHelpFunc() {
  const client = useApolloClient();

  const isUserNameUnique = useCallback(
    async (userName: string, userId: number) => {
      const where = {
        userName: userName,
        id: { $ne: userId },
      };

      const ret = await client.query({
        query: gql`
          query getUsers($where: String) {
            getUsers(where: $where) {
              recordCount
            }
          }
        `,
        variables: {
          where: JSON.stringify(where),
        },
        fetchPolicy: 'network-only',
      });
      return (ret?.data?.getUsers?.recordCount ?? 0) === 0;
    },
    [client],
  );

  return { isUserNameUnique };
}

export function getFileUrl(client: ApolloClient<object>, id: number): Promise<string> {
  return new Promise((resolve, reject) => {
    // console.log('id=', id);
    client
      .query<any, { id: number }>({
        query: gql`
          query getFilesrepositoryFileUrlById($id: Int) {
            getFilesrepositoryFileUrlById(id: $id)
          }
        `,
        variables: { id },
        fetchPolicy: 'network-only',
      })
      .then((res) => {
        if (res.data.getFilesrepositoryFileUrlById !== null) {
          let fileUrl = res.data.getFilesrepositoryFileUrlById;
          fileUrl = fileUrl.substr(0, fileUrl.indexOf('?'));
          console.log('fileUrl= ', fileUrl);
          resolve(fileUrl);
        } else {
          reject(res.errors[0].message);
        }
      })
      .catch((err) => reject(err));
  });
}

export function useGetFileUrl(fileId: number): string {
  const client = useApolloClient();

  // Signature Url
  const [url, setUrl] = useState('');
  useEffect(() => {
    if (!fileId) {
      setUrl('');
      return;
    }

    getFileUrl(client, fileId)
      .then((result) => {
        setUrl(result);
      })
      .catch(() => {
        setUrl('');
      });
  }, [client, fileId]);

  return url;
}

export function useGetMaterialById() {
  const client = useApolloClient();
  const gqlScript = gql`
    query getQuery($id: Int) {
      getMaterialById(id: $id) {
        id
        name
        defEkaCode
        ekaCodeValues
        defUnClass
        unClassValues
      }
    }
  `;

  async function getMaterialById(id: number): Promise<any> {
    const ret = await client.query({
      query: gqlScript,
      variables: { id },
      fetchPolicy: 'network-only',
    });
    return ret?.data?.getMaterialById;
  }

  return { getMaterialById };
}

export function useGetUserByName() {
  const client = useApolloClient();
  const gqlScript = gql`
    query getQuery($name: String) {
      getUserByName(name: $name) {
        id
        userName
        lastName
        firstName
        email
        tel
        mobile1
        position
        notes
        changePasswordNextTime
        signatureFileId
      }
    }
  `;

  async function getUserByName(name: string): Promise<any> {
    const ret = await client.query({
      query: gqlScript,
      variables: { name },
      fetchPolicy: 'network-only',
    });
    return ret?.data?.getUserByName;
  }

  return { getUserByName };
}
